module.exports = __webpack_public_path__ + "static/img/bg-fr.9d32fc27.png";